<template>
    <div>
        <slot name="tablist" :tabs="tabs" :selectTab="selectTab">
            <div class="container flex overflow-x-auto">
                <button
                    type="button"
                    class="px-6 py-2 text-lg cursor-pointer focus:outline-none"
                    v-for="tab in tabs"
                    :key="tab.id"
                    :class="
                        tab.isActive
                            ? 'text-dark bg-white font-medium'
                            : 'hover:text-blue-1 text-gray-1'
                    "
                    @click="selectTab(tab)"
                >
                    {{ tab.name }}
                </button>
            </div>
        </slot>

        <slot></slot>
    </div>
</template>

<script>
export default {
    props: ["padded"],

    data() {
        return {
            tabs: [],
            withPadding: false,
        };
    },

    created() {
        this.tabs = this.$children;
        this.tabs.withPadding = this.padded;
    },

    methods: {
        selectTab(selectedTab) {
            this.tabs.forEach((tab) => {
                tab.isActive = tab.name == selectedTab.name;
            });
        },
    },
};
</script>
